// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my_divider[data-v-5441682c]{border:4px solid;border-radius:2px;max-width:5rem}", ""]);
// Exports
module.exports = exports;
